"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _main = _interopRequireDefault(require("./main.c"));

var _dataModel = _interopRequireDefault(require("../../../common/backbone/dataModel"));

var _default =
/*#__PURE__*/
function (_View) {
  (0, _inherits2["default"])(_default, _View);

  function _default() {
    (0, _classCallCheck2["default"])(this, _default);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(_default).apply(this, arguments));
  }

  (0, _createClass2["default"])(_default, [{
    key: "submit",

    /**
     * form submit event default callback
     * @param {object} event
     */
    value: function submit() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (event.nativeEvent) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (typeof this.componentWillSubmit === 'function') {
        this.componentWillSubmit();
      }

      var data = this.getFormData(),
          model = this.getModel();

      if (typeof this.componentDidSubmit === 'function' && typeof this.validate === 'function' && this.validate(data)) {
        this.componentDidSubmit(data, model);
      }
    }
    /**
     * Component lifecycle method
     * It should be run AFTER success completion of this.submit processing
     * @param {object} data
     * @param {object} model
     */

  }, {
    key: "componentDidSubmit",
    value: function () {
      var _componentDidSubmit = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee() {
        var data,
            model,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                model = _args.length > 1 ? _args[1] : undefined;
                _context.prev = 2;
                _context.next = 5;
                return this.uiStandBy();

              case 5:
                if (!(model instanceof _dataModel["default"])) {
                  _context.next = 11;
                  break;
                }

                _context.next = 8;
                return model.save(data);

              case 8:
                if (typeof this.props.toNextStep === 'function') {
                  this.props.toNextStep();
                }

                _context.next = 12;
                break;

              case 11:
                if (typeof this.props.toNextStep === 'function') {
                  this.props.toNextStep(data);
                }

              case 12:
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](2);
                this.errorHandler(_context.t0);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 14]]);
      }));

      function componentDidSubmit() {
        return _componentDidSubmit.apply(this, arguments);
      }

      return componentDidSubmit;
    }()
    /**
     * Component lifecycle method
     * It should be run BEFORE this.submit processing
     */

    /* componentWillSubmit() {
    }*/

  }]);
  return _default;
}(_main["default"]);

exports["default"] = _default;
(0, _defineProperty2["default"])(_default, "displayName", 'Base.Views.Form');